import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const LoadingIndicator = ({ height }) => {
  return (
    <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </div>
  );
};

LoadingIndicator.propTypes = {
  height: PropTypes.string,
};

export default LoadingIndicator;
